<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <br />
  <!-- CADASTRO-->
  <div class="card card-primary">
    <div class="card-header">
      <h3 class="card-title" style="color: white">Contato</h3>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="leilao_info_geral">Nome</label>
            <input :disabled="user_defined" style="color: black" class="form-control" v-model="formData.nome" id="conteudo_notificacao" />

            <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-12" v-if="user">
          <div class="form-group">
            <label for="leilao_info_geral">Apelido</label>
            <input :disabled="user_defined" style="color: black" class="form-control" v-model="formData.apelido" id="conteudo_notificacao" />
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label for="leilao_info_geral">Telefone</label>
            <input :disabled="user_defined" style="color: black" class="form-control" v-model="formData.telefone" id="conteudo_notificacao" />

            <span style="color: red" v-for="error in v$.telefone.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label for="leilao_info_geral">E-mail</label>
            <input :disabled="user_defined" style="color: black" class="form-control" v-model="formData.email" id="conteudo_notificacao" />

            <span style="color: red" v-for="error in v$.email.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label for="leilao_info_geral">Sua mensagem</label>
            <textarea class="form-control" v-model="formData.mensagem" rows="2" cols="50"></textarea>

            <span style="color: red" v-for="error in v$.mensagem.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button type="submit" class="btn btn-primary" @click="validate()">Enviar</button>
    </div>
  </div>
</template>

<script>
import wppController from "../controller/wppController.js";
import sweetAlert from "../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import currencyController from "../controller/currencyController.js";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required, minLength } from "../locales/i18n.js";
import { computed, reactive } from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [sweetAlert, Swal],

  props: ["lote", "user"],

  components: { Loading },

  data() {
    return {
      user_defined: false,
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      apelido: "",
      nome: "",
      telefone: "",
      email: "",
      mensagem: "",
    });

    const rules = computed(() => {
      let local_rules = {
        nome: { required },
        telefone: { required, minLength: minLength(11) },
        email: { required, validateEmail: helpers.withMessage(" Digite um e-mail válido.", validateEmail) },
        mensagem: { required },
      };

      return local_rules;
    });

    const validateEmail = (value) => {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Meu user contato");
    console.log(this.user);
    console.log(this.pre_assunto);

    if (this.user) {
      this.formData.apelido = this.user.apelido;
      this.formData.email = this.user.email;
      this.user_defined = true;

      if (this.user.profile) {
        this.formData.telefone = this.user.profile.telefone_celular;
        this.formData.nome = this.user.profile.nome_completo;
      }
    }

    if (this.fotos && this.fotos.length) {
      this.foto_selecionada = this.fotos[0];
    }
  },

  methods: {
    async validate() {
      const result = await this.v$.$validate();

      console.log(this.v$);
      console.log(this.v$.$errors);

      if (result) {
        this.send();
      }
    },

    send() {
      this.isLoading = true;

      let corpo = "Nome: " + this.formData.nome;

      if (this.user) {
        corpo = corpo + "<br/><br/>Apelido: " + this.formData.apelido;
      }

      corpo =
        corpo +
        "<br/><br/>Email: " +
        this.formData.email +
        "<br/><br/>Telefone: " +
        this.formData.telefone +
        "<br/><br/>Tela: " +
        window.location.href +
        "<br/><br/>Mensagem: " +
        this.formData.mensagem +
        "<br/><br/><br/>";

      let data = {
        pre_assunto: this.pre_assunto,
        corpo: corpo,
        email: this.formData.email,
        mailModel: "Contatogeral",
      };

      if (this.user && this.user.id) {
        data.user_id = this.user.id;
      }

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/mail/send_contato`, data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessageWithButtonAndRedirect("Sucesso!", "Mensagem enviada", "/");
          //this.showSuccessMessageWithButton("Sucesso!");

          let btn = document.getElementById("fechar_editar");

          btn.click();
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.card-body {
  width: 600px;
}

@media screen and (max-width: 1200px) {
  .card-body {
    width: 600px;
  }
}

@media screen and (max-width: 1100px) {
  .card-body {
    width: 600px;
  }
}

@media screen and (max-width: 960px) {
  .card-body {
    width: 750px;
  }
}

@media screen and (max-width: 800px) {
  .card-body {
    width: 600px;
  }
}

@media screen and (max-width: 600px) {
  .card-body {
    width: 100%;
  }
}
</style>
